export enum PlanEnum {
  FREEMIUM = "freemium",
  STARTER = "starter",
  PROFESSIONAL = "professional",
  ENTERPRISE = "enterprise",
}
